import { SubscriptionUpgradeStatus } from '@/types/subscriptionUpgrade';

/**
 * Determina si una suscripción puede ser seleccionada para upgrade
 * Las suscripciones que ya han sido actualizadas, falladas, canceladas o expiradas no deberían poder seleccionarse
 */
export const canSelectSubscriptionForUpgrade = (
  upgradeStatus?: string, 
  hasPendingUpgrade?: boolean
): boolean => {
  // Si no tiene upgrade, se puede seleccionar
  if (!hasPendingUpgrade) return true;
  
  // Si tiene un estado terminal, no se puede seleccionar
  if (!upgradeStatus) return true;
  
  const terminalStates = [
    'pending',
    'upgraded',
    'failed',
    'cancelled',
    'expired'
  ];
  
  return !terminalStates.includes(upgradeStatus);
};